import React from 'react';
import { DEFAULT_GLASS_SIZE_TOTALS, replaceZerosWithDash } from 'domain/glass';

import { View } from '@react-pdf/renderer';
import PdfGlassConfigTableRow from './PdfGlassConfigTableRow';
import PdfGlassConfigTableHeadingRow from './PdfGlassConfigTableHeadingRow';
import PdfGlassConfigTotal from './PdfGlassConfigTotal';

import styles from '../styles';

const PdfGlassConfigTable = ({
	positions,
	totalValues,
	oversizedGlassFields,
	glassIndex,
	startIndex,
	showTotal,
	showPrice,
	priceVolumeCat,
}) => {
	let total = { ...DEFAULT_GLASS_SIZE_TOTALS };
	if (totalValues?.length) {
		const totalSum = totalValues.reduce(
			(acc, { quantity, m2, linearMeterPos, kgPos, hasPrice, prices }) => {
				// totals for this glass type
				return {
					quantity: acc.quantity + quantity,
					m2: acc.m2 + m2,
					linearMeter: acc.linearMeter + linearMeterPos,
					kg: acc.kg + kgPos,
					prices:
						hasPrice && prices
							? Object.keys(prices).reduce(
									(sum, key) => {
										return { ...sum, [key]: (acc.prices[key] || 0) + (prices[key] || 0) };
									},
									{ ...acc.prices }
								)
							: acc.prices,
					hasAllPrices: hasPrice && acc.hasAllPrices,
				};
			},
			{
				quantity: 0,
				m2: 0,
				linearMeter: 0,
				kg: 0,
				hasAllPrices: true,
				prices: { 0: 0 },
			}
		);
		total = replaceZerosWithDash(totalSum);
	}

	return (
		<View style={styles.glassConfigTableList} wrap={false}>
			{positions && positions.length ? (
				<>
					<PdfGlassConfigTableHeadingRow showPrice={showPrice} />
					<View style={styles.block}>
						{positions.map((positionRow, chunkIndex) => {
							const rowIndex = startIndex + chunkIndex;
							const displayPosition = `${glassIndex + 1}.${rowIndex + 1}`;

							const emptyRow = positionRow.row.every(
								item =>
									!(
										(item.name === 'length' || item.name === 'width' || item.name === 'quantity') &&
										item.value !== ''
									)
							);

							return emptyRow ? null : (
								<PdfGlassConfigTableRow
									key={rowIndex}
									tableRow={positionRow}
									attrKey={rowIndex}
									rowIndex={rowIndex}
									displayPosition={displayPosition}
									totalValues={totalValues?.find(o => o.index === rowIndex)}
									oversizedGlassFields={oversizedGlassFields?.find(o => o.id === positionRow.id)}
									showPrice={showPrice}
									priceVolumeCat={priceVolumeCat}
								/>
							);
						})}
					</View>
					{showTotal && (
						<PdfGlassConfigTotal {...total} showPrice={showPrice} priceVolumeCat={priceVolumeCat} />
					)}
				</>
			) : null}
		</View>
	);
};

export default PdfGlassConfigTable;
